import { WitaConnector } from '@/services/repository/connector'
import { querySerializer } from '@/utils/helpers/URLs'

import {
  CreateVistaProdutoParams,
  CreateVistaProdutoResponse,
  DeleteVistaProdutoParams,
  DeleteVistaProdutoResponse,
  EditVistaProdutoParams,
  EditVistaProdutoResponse,
  FindVistaProdutosByVistaIdParams,
  FindVistaProdutosByVistaIdResponse,
} from '../domain/vista-produto'

const ROOT_URL = '/entity/vista-products'

export const VistaProdutoService = {
  findByVistaId: async (params: FindVistaProdutosByVistaIdParams) => {
    const url = ROOT_URL + `?${querySerializer(params)}`
    return await WitaConnector.get<FindVistaProdutosByVistaIdResponse>(url)
  },

  create: async (params: CreateVistaProdutoParams) => {
    const url = ROOT_URL
    return await WitaConnector.post<CreateVistaProdutoResponse>(url, params)
  },

  edit: async ({ id, ...params }: EditVistaProdutoParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.put<EditVistaProdutoResponse>(url, params)
  },

  delete: async ({ id }: DeleteVistaProdutoParams) => {
    const url = ROOT_URL + `/${id}`
    return await WitaConnector.delete<DeleteVistaProdutoResponse>(url)
  },
}
